import LoginPage from "../components/Login";
import RegisterPage from "../components/LoginRegister";

export const auth_routes = [
    { 
        path: "/", 
        ele: <LoginPage></LoginPage>, 
    },
    { 
        path: "/login", 
        ele: <LoginPage></LoginPage>, 
    },
    { 
        path: "/register", 
        ele: <RegisterPage></RegisterPage>, 
    }
]